import { Component, OnDestroy, OnInit } from '@angular/core';
import { UsersService } from '../../../../services/users/user.service.js';
import { UsersFilterService } from '../../../../services/users/user-filter.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { KeyValuePair } from 'allai-admin-shared';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';

/** The user metric page */
@Component({
	selector: 'app-user-metrics',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule,
		MatDatepickerModule,
		MatFormFieldModule,
		FormsModule,
		MatInputModule,
		MatTableModule,
		ReactiveFormsModule,
		OverlayModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './user-metrics.component.html',
	styleUrl: './user-metrics.component.scss'
})
export class UserMetricsComponent implements OnInit, OnDestroy {

	dateRangeControl: FormGroup;

	metricsDataSource: MatTableDataSource<KeyValuePair>;

	readonly displayedColumns: (keyof KeyValuePair)[] = ['key', 'value'];

	constructor(private usersService: UsersService, private usersFilterService: UsersFilterService) {

	}

	ngOnInit() {

		this.dateRangeControl = new FormGroup({
	    start: new FormControl<Date | null>(this.usersFilterService.metricsStartDate),
  	  end: new FormControl<Date | null>(this.usersFilterService.metricsEndDate)
	  });
		this.dateRangeControl.valueChanges.subscribe((value) => this.usersFilterService.metricsRange = value);

		this.usersService.onNewUserDetail.subscribe(() => {
			this.refresh();
		});
	}

	private refresh() {
		let userDetail = this.usersService.userDetail;
		let data = userDetail.metrics;
		this.metricsDataSource = new MatTableDataSource<KeyValuePair>(data);
	}

	ngOnDestroy() {
	}
}
